<template>
  <div :class="['definition-wrapper', 'date', definition.id, {'error_validate': mandatoryValidation || validation}, {'ok_validate': !mandatoryValidation && !validation && dateValue}]">
    <div v-if="editable">
      <date-picker
        v-model:value="dateValue"
        :lang="lang"
        :format="format"
        :first-day-of-week="firstDayOfWeek"
        :confirm="confirm"
        :shortcuts="shortcuts.length ? shortcuts : null"
        :editable="isManualEditable"
        :input-name="definition.id"
        :type="getType()"
        :minute-step="minuteStep"
        :not-before="disabledDates.to"
        :not-after="disabledDates.from"
        :show-week-number="false"
        @change="valueChanged($event)"
      />
    </div>
    <definition-read-only v-else :definitionId="definitionId" :definition="definition" :object="object" :visualDefinition="visualDefinition" />
  </div>
</template>

<script>
import moment from 'moment'
import DefinitionReadOnly from './readOnly'
import DatePicker from 'vue-datepicker-next'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../language'

export default {
  name: 'definition-date',
  components: {
    DefinitionReadOnly,
    DatePicker
  },
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'language',
    'visualDefinition',
    'placeholder',
    'callTask'
  ],
  data () {
    return {
      dateValue: null,
      format: this.getFormat(),
      firstDayOfWeek: 1,
      confirm: false,
      shortcuts: [],
      isManualEditable: true,
      validation: null,
      minuteStep: 5,
      disabledDates: {}
    }
  },
  beforeMount () {
    this.getDisabledDates()
    this.dateValue = this.getDateValue(this.object)
  },
  methods: {
    getDisabledDates () {
      if (this.definition.questLogicFlow) {
        var dateRangeArr = this.definition.questLogicFlow.split(':')
        if (dateRangeArr.length === 3) {
          var dateRangeExp = dateRangeArr[0]
          var disabledTo = dateRangeArr[1]
          var disabledFrom = dateRangeArr[2]

          if (dateRangeExp === 'dateRange') {
            if (disabledTo && disabledTo !== '') {
              if (disabledTo === 'today') {
                this.disabledDates.to = new Date()
              } else {
                this.disabledDates.to = moment(disabledTo, 'YYYYMMDD').toDate()
              }
            }
            if (disabledFrom && disabledFrom !== '') {
              if (disabledFrom === 'today') {
                this.disabledDates.from = new Date()
              } else {
                this.disabledDates.from = moment(disabledFrom, 'YYYYMMDD').toDate()
              }
            }
          }
        }
      }
    },
    // 1. Launch validate mandatory event on date change
    valueChanged (event) {
      this.setDateValue()
      this.$emit('validateMandatory', moment().valueOf(), this.object)
    },
    validateDateFormat () {
      if (this.dateValue && this.dateValue !== '') {
        this.validation = transport.methods.validateDateFormat(this.definition, this.dateValue)
        // 3. if date format validation past...
        if (this.validation === null) {
          // ... set date text value and launch refresh definition event
          this.$emit('refreshDefinition', this.object)
        } else {
          // ... or launch date format error event to show error message
          this.$emit('dateFormatError', moment().valueOf(), this.validation, this.definition.validation.format)
        }
      } else {
        this.$emit('refreshDefinition')
      }
    },
    getDateValue (object) {
      var result = null
      if (object.textValue && object.textValue !== '') {
        result = transport.methods.getDate(object.textValue, this.definition)
      }
      return result
    },
    setDateValue () {
      this.object.textValue = `${transport.methods.getDateStr(this.dateValue, this.definition)}`
    },
    getFormat () {
      return transport.methods.getDateFormat(this.definition.validation.format.regExp)
    },
    getType () {
      var result
      if (this.definition.type === 'duration') {
        result = 'time'
      } else {
        result = this.definition.type
      }
      return result
    }
  },
  computed: {
    lang () {
      let aux = language(this.language, 'datepicker')
      let result

      if (aux instanceof Object) {
        result = JSON.parse(JSON.stringify(aux))

        if (this.placeholder) {
          result.placeholder.date = this.placeholder
        } else if (this.definition.type === 'duration') {
          result.placeholder.date = result.placeholder.duration
        } else if (this.definition.type === 'time') {
          result.placeholder.date = result.placeholder.time
        }
      } else {
        result = aux
      }

      return result
    }
  },
  watch: {
    mandatoryValidation (value) {
      // 2. if mandatory validation past...
      if (value && (value.validateKey === null || value.validateKey.trim() === '')) {
        // ... launch date format validation
        this.validateDateFormat()
      }
    },
    object: {
      handler (object) {
        this.dateValue = this.getDateValue(object)
      },
      deep: true
    }
  }
}
</script>

<style>
.mx-input {
  box-shadow: none;
  border: 1px solid #e8e8e8;
  min-height: 33px;
  font-size: 14px;
  border-radius: 2px;
}
.mx-input-append {
  padding: 0;
  width: 13.5px;
  right: 10px;
}
</style>
